
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component
export default class InvoiceTitleModal extends Vue {
  visible = false;

  loading = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('formRef')
  readonly formRef!: FormModel;

  distributor: any = null;

  dataSource: any[] = [];

  form = {
    contact_name: '',
    contact_phone: '',
    tax_id: '',
    bank_name: '',
    bank_account: '',
    invoice_address: '',
    invoice_phone: '',
    invoice_shop_name: '',
  };

  rules = {
    contact_name: [
      { required: true, message: '请输入联系人', trigger: 'blur' },
    ],
    contact_phone: [
      { required: true, message: '请输入联系电话', trigger: 'blur' },
    ],
    tax_id: [{ required: true, message: '请输入税号', trigger: 'blur' }],
    bank_name: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
    bank_account: [
      { required: true, message: '请输入开户账号', trigger: 'blur' },
    ],
    invoice_address: [
      { required: true, message: '请输入注册地址', trigger: 'blur' },
    ],
    invoice_phone: [
      { required: true, message: '请输入注册电话', trigger: 'blur' },
    ],
    invoice_shop_name: [
      { required: true, message: '请输入发票抬头', trigger: 'blur' },
    ],
  };

  async open(record: any) {
    this.distributor = record;
    const res = await this.supplyService.getDistributorDetail(record.sdCode);
    if (res) {
      const {
        contact_name,
        contact_phone,
        tax_id,
        bank_name,
        bank_account,
        invoice_address,
        invoice_phone,
        invoice_shop_name,
      } = res;
      this.form = {
        contact_name,
        contact_phone,
        tax_id,
        bank_name,
        bank_account,
        invoice_address,
        invoice_phone,
        invoice_shop_name,
      };
    }
    this.visible = true;
  }

  handleCancel() {
    this.visible = false;
    this.formRef.resetFields();
  }

  handleOk() {
    this.formRef.validate(async (valid: boolean) => {
      if (valid) {
        console.log('form', this.form);
        const res = await this.supplyService.postEditDistributor(this.distributor.sdCode, this.form);
        if (res) {
          this.$message.success('修改成功');
          this.visible = false;
          this.$emit('refresh');
        }
      }
    });
  }

  getList() {
    // TODO: 调用发票抬头列表接口
    this.dataSource = [];
  }

  editInvoiceTitle(record: any) {
    // TODO: 编辑发票抬头
    console.log(record);
  }

  deleteInvoiceTitle(record: any) {
    // TODO: 删除发票抬头
    console.log(record);
  }
}
